import { sendTrace } from '../perf'

// A session sends a trace per query it runs, so only a fraction of sessions
// report — enough for percentiles without flooding Performance Monitoring.
const SAMPLE_RATE = 0.2
const sampled = Math.random() < SAMPLE_RATE

// Collection names only (events/stages, users/private) — ids would explode the
// attribute's cardinality.
export function collectionLabel(path: string): string {
  return path.split('/').filter((_, i) => i % 2 === 0).join('/') || '(query)'
}

// `fs_listen`: subscribe → first server snapshot, with how long the cache
// answer took when there was one.
export function listenTimer(path: string) {
  const wall = Date.now()
  const start = performance.now()
  let cacheMs: number | undefined
  let done = !sampled
  return (fromCache: boolean, docs: number) => {
    if (done) return
    const elapsed = performance.now() - start
    if (fromCache) {
      cacheMs ??= Math.round(elapsed)
      return
    }
    done = true
    sendTrace(
      'fs_listen',
      wall,
      elapsed,
      { collection: collectionLabel(path), cache_hit: cacheMs === undefined ? 'no' : 'yes' },
      cacheMs === undefined ? { docs } : { docs, cache_ms: cacheMs },
    )
  }
}

// `fs_get`: one getDocs / getDocsCacheFirst / getDoc, from the cache or the server.
export function getTimer(path: string) {
  const wall = Date.now()
  const start = performance.now()
  return (fromCache: boolean, docs: number) => {
    if (!sampled) return
    sendTrace(
      'fs_get',
      wall,
      performance.now() - start,
      { collection: collectionLabel(path), source: fromCache ? 'cache' : 'server' },
      { docs },
    )
  }
}
